<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px' }"
  (onHide)="closeDialog()"
>
  <ng-template pTemplate="header">
    <div class="w-100 text-center">
      <span class="h3 fw-bold">Verify Transaction</span>
    </div>
  </ng-template>

  <div class="px-3">
    <div
      class="d-flex justify-content-between align-items-center py-2 border-bottom"
      *ngFor="let item of data"
    >
      <div class="fw-bold text-dark">{{ item.key }}</div>
      <div class="text-muted">{{ item.value }}</div>
    </div>
  </div>

  <div class="text-center py-4 px-3">
    <div
      *ngIf="!hideTimer"
      class="timer-display mb-3"
      [class.text-danger]="isExpired"
      [class.text-primary]="!isExpired"
    >
      <span class="h3 fw-bold">{{ timerDisplay }}</span>
    </div>

    <div
      *ngIf="isExpired && !hideTimer"
      class="alert alert-danger mb-3"
    >
      Code has expired. Please close and generate a new code.
    </div>

    <div class="h5 fw-bold mb-1">Enter Cash Withdrawal Code</div>
    <div class="text-muted small mb-3">that sent to customer</div>
    <div class="d-flex justify-content-center mb-3">
      <p-inputOtp
        [(ngModel)]="verificationCode"
        [length]="verificationCodeLength"
        [integerOnly]="true"
        (ngModelChange)="onVerificationCodeChange($event)"
        [disabled]="isExpired || isLoading"
      ></p-inputOtp>
    </div>

    <div
      class="text-start mx-auto d-grid gap-3 w-100"
      style="max-width: 340px"
    >
      <div>
        <label
          htmlFor="trnUserCode"
          class="form-label fw-semibold mb-1"
        >
          User ID
        </label>
        <div class="input-group">
          <span class="input-group-text bg-light text-muted">
            <i class="pi pi-user"></i>
          </span>
          <input
            pInputText
            id="trnUserCode"
            name="cashWithdrawalManualUserCode"
            type="text"
            [(ngModel)]="trnUserCode"
            (ngModelChange)="trnUserCode = $event.trim()"
            (focus)="enableCredentialInputs()"
            placeholder="CBS User ID"
            class="form-control bg-white shadow-none"
            autocomplete="off"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            [readonly]="credentialInputsReadonly"
            [disabled]="isExpired || isLoading"
          />
        </div>
      </div>

      <div>
        <label
          htmlFor="trnPassUserCode"
          class="form-label fw-semibold mb-1"
        >
          User Password
        </label>
        <div class="input-group">
          <span class="input-group-text bg-light text-muted">
            <i class="pi pi-lock"></i>
          </span>
          <input
            pInputText
            id="trnPassUserCode"
            name="cashWithdrawalManualUserSecret"
            [type]="showTrnPassword ? 'text' : 'password'"
            [(ngModel)]="trnPassUserCode"
            (focus)="enableCredentialInputs()"
            placeholder="CBS User Password"
            class="form-control bg-white shadow-none"
            autocomplete="new-password"
            autocapitalize="off"
            autocorrect="off"
            spellcheck="false"
            [readonly]="credentialInputsReadonly"
            [disabled]="isExpired || isLoading"
          />
          <button
            class="btn btn-outline-secondary shadow-none"
            type="button"
            (click)="toggleTrnPasswordVisibility()"
            [disabled]="isExpired || isLoading"
            [attr.aria-label]="showTrnPassword ? 'Hide password' : 'Show password'"
          >
            <i [class]="showTrnPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <hr />
    <div class="d-flex justify-content-center gap-2">
      <button
        class="btn btn-outline-secondary"
        (click)="closeDialog()"
        [disabled]="isLoading"
      >
        Back
      </button>
      <button
        class="btn btn-primary"
        (click)="onConfirm()"
        [disabled]="!canConfirm()"
      >
        <span
          *ngIf="isLoading"
          class="spinner-border spinner-border-sm me-2"
        ></span>
        {{ isLoading ? 'Processing...' : 'Confirm' }}
      </button>
    </div>
  </ng-template>
</p-dialog>
